var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},_vm._l((_vm.$locales),function(lang,i){return _c('a',{key:`Lang${i}`,staticClass:"locale-changer__button",attrs:{"href":`${lang.base}${_vm.path}`}},[_c('img',{attrs:{"src":require(`@/assets/images/${lang.locale}.png`),"alt":lang.title}}),_c('span',[_vm._v(_vm._s(lang.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }